import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

import { FinishSurveyDialog } from 'modules/engagement_surveys/components/SurveyResourceHeader/FinishSurveyDialog'

type Data = {
  formId: string
}

export const FinishSurveyActivity: ActivityComponent<Data> = ({ formId }) => {
  const { open, closeActivity } = useActivity()

  if (!open) return null

  return <FinishSurveyDialog formId={formId} onSuccess={closeActivity} onCancel={closeActivity} />
}
